module.exports = __webpack_public_path__ + "9291e6e31e66f7348a64d96cfed4adc1.png";